<template>
  <div class="teach_detail">
    <!-- <div class="teach_top">
      <p>{{queryTime}}日情况收集({{total}}人) <span>异常{{abnormal}}人</span></p>
    </div> -->
    <van-tabs v-model="active" class="teach_tab_wrap" color="#1A8FFF" line-width=".8rem" sticky @change="handleChangeTabs">
      <van-tab v-for="item in teachTabs" :key="item.id" class="teach_tab_list">
        <template #title>
          {{item.name}}
          <span :class="{
            'loss': item.type === 'loss',
            'abnormal': item.type === 'abnormal'
          }">({{nums[item.type]}})</span>
        </template>
        <div v-if="pList && pList.length > 0" class="detail_list">
          <PeopleInfoItem v-for="val in pList" :key="val.id" :info="val" :type="item.type" @onShow="handleShowRecords" />
        </div>
        <p v-else class="no_more">没有更多了~</p>
      </van-tab>
    </van-tabs>
    <div class="suppl_btn" @click="handleToBu">
      <img src="../assets/images/icon-b.png" />
      <p>补录</p>
    </div>

    <RecordPopup ref="popRef" :queryTime="queryTime" />
  </div>
</template>

<script>
import PeopleInfoItem from '../components/PeopleInfoItem.vue'
import RecordItemNew from '../components/RecordItemNew.vue'
import RecordPopup from '../components/RecordPopup.vue'
import { get } from '../commen/http'
import { teachTabs } from '../commen/constants'
import { peopleList } from '@/api/index.js'
export default {
  components: {
    PeopleInfoItem,
    RecordItemNew,
    RecordPopup
  },
  data() {
    return {
      loading: false,
      finished: false,
      queryTime: this.$route.query.queryTime,
      total: this.$route.query.total,
      abnormal: this.$route.query.abnormal,
      // 一级id
      companyId: this.$route.query.companyId,
      // 二级id
      gradeId: this.$route.query.gradeId,
      // 三级id
      classId: this.$route.query.classId,
      // 正常异常
      temperatureStatus: '',
      // 记录列表
      rList: [],
      // 人员列表
      pList: [],
      active: 0,
      teachTabs: teachTabs,
      // 填报记录弹框
      showRecords: false,
      // 上报状态
      reportStatus: '',
      // 数量
      nums: {
        'all': 0,
        'normal': 0,
        'abnormal': 0,
        'loss': 0
      }
    }
  },
  methods: {
    handleChangeTabs(index) {
      if(this.active === 0) {
        this.reportStatus = ''
      }
      if(this.active === 1) {
        this.reportStatus = '0'
      }
      if(this.active === 2) {
        this.reportStatus = '1'
      }
      if(this.active === 3) {
        this.reportStatus = '2'
      }
      this.fetchPeopleList();
    },

    // 获取人数
    async fetchNumbers() {
      if(!this.gradeId) {
        this.gradeId = ''
      }
      if(!this.classId) {
        this.classId = ''
      }
      const toast = this.$toast.loading({
        message: '加载中...',
        duration: 0
      })
      const res = await get({
        url: '/api/total/day/amount',
        data: {
          companyId: this.companyId,
          gradeId: this.gradeId,
          classId: this.classId,
          queryTime: this.queryTime
        }
      })
      if(res.code === 1) {
        this.nums['all'] = res.data.total
        this.nums['normal'] = res.data.normal
        this.nums['abnormal'] = res.data.abnormal
        this.nums['loss'] = res.data.loss
        toast.clear();
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
    },

    // 获取填报人员列表
    async fetchPeopleList() {
      if(!this.gradeId) {
        this.gradeId = ''
      }
      if(!this.classId) {
        this.classId = ''
      }
      const toast = this.$toast.loading({
        message: '加载中...',
        duration: 0
      })
      const res = await get({
        url: '/api/total/v2/day',
        data: {
          companyId: this.companyId,
          gradeId: this.gradeId,
          classId: this.classId,
          queryTime: this.queryTime,
          reportStatus: this.reportStatus
        }
      })
      if(res.code === 1) {
        this.pList = res.data;
        toast.clear();
      }else {
        this.$toast({
          message: res.message,
          position: 'bottom'
        });
      }
    },

    // 点击跳转补录
    handleToBu() {
      this.$router.push({
        path: '/recode',
        query: {
          companyId: this.companyId,
          gradeId: this.gradeId,
          classId: this.classId,
          date: this.queryTime
        }
      })
    },

    // 点击展示
    handleShowRecords(id) {
      this.$refs.popRef._show(id)
    },

    // 点击关闭
    handleCloseP() {
      this.showRecords = false
      this.rList = []
    }
  },
  mounted() {
    this.fetchNumbers()
    this.fetchPeopleList()
  }
}
</script>

<style>
.teach_tab_wrap .van-tab {
  font-size: .32rem;
  color: #333;
  line-height: .4rem;
}
.teach_tab_wrap .van-tabs__wrap {
  height: .88rem;
  border-bottom: 1px solid #D8D8D8;
}
</style>
<style scoped>
.teach_detail {
  box-sizing: border-box;
  min-height: 100%;
  background-color: #F3F4F6;
  padding-bottom: .3rem;
}
.detail_list {
  box-sizing: border-box;
  padding: 0 .25rem;
}
.teach_tab_list {
  box-sizing: border-box;
  padding-top: .28rem;
}
.no_more {
  font-size: .28rem;
  color: #999;
  text-align: center;
}
.suppl_btn {
  position: fixed;
  bottom: 1.7rem;
  right: .3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.96rem;
  height: .76rem;
  border-radius: .38rem;
  box-shadow: 0px 4px 13px 0px rgba(51, 119, 154, 0.29);
  background-color: #1a8fff;
}
.suppl_btn > p {
  font-size: .28rem;
  color: #fff;
}
.suppl_btn > img {
  width: .3rem;
  height: .3rem;
  margin-right: .15rem;
}
.teach_tab_wrap .loss {
  color: #FF8D05;
}
.teach_tab_wrap .abnormal {
  color: #FF5E5B;
}
</style>